import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_record_editorService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { billingTaskId: number }): 
  Promise<{ result: { BillingTaskId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.billingTaskId)) {
      $missingRequiredInParams.push('\'billingTaskId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      billingTaskId: number    }) {
        if(isNil($inParams.billingTaskId)) {
          return true; 
        }
      return false;
    }
}
